<template>
    <div class="card card-height">
        <div class="table-container">
            <table class="table create-billing table-width table-bordered">
                <thead>
                    <tr>
                        <th>{{ reportType === 'user' ? 'User' : 'Date' }}</th>
                        <th class="text-right">Total Amount</th>
                        <th class="text-right">Discount</th>
                        <th class="text-right">Reward Point Redeemed</th>
                        <th class="text-right">Total Collection</th>
                        <th class="text-right">Refund Payment</th>
                        <th class="text-right">Net Collection</th>
                        <th class="text-right" v-for="mop in mopHeads" :key="mop.key">
                          {{ mop.label }}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(item, index) in tableItems" :key="index">
                        <td>{{ reportType === 'user' ? (item.user_name || 'Walk-in Customer') : formatToDdMmmYy(item.receipt_date) }}</td>
                        <td class="text-right">{{ commaFormat(item.total_sale_amount) }}</td>
                        <td class="text-right">{{ commaFormat(item.total_sale_discount) }}</td>
                        <td class="text-right">{{ commaFormat(item.total_point_redeemed) }}</td>
                        <td class="text-right">{{ commaFormat(item.total_paid_amount) }}</td>
                        <td class="text-right">{{ commaFormat(item.total_refund_amount) }}</td>
                        <td class="text-right">{{ commaFormat(item.total_paid_amount - item.total_refund_amount) }}</td>
                        <td class="text-right" v-for="mop in mopHeads" :key="mop.key">
                          {{ commaFormat((item.mop_heads && item.mop_heads[mop.key]) || 0) }}
                        </td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr>
                        <td><strong>Total</strong></td>
                        <td class="text-right">{{ commaFormat(totals.total_sale_amount) }}</td>
                        <td class="text-right">{{ commaFormat(totals.total_sale_discount) }}</td>
                        <td class="text-right">{{ commaFormat(totals.total_point_redeemed) }}</td>
                        <td class="text-right">{{ commaFormat(totals.total_paid_amount) }}</td>
                        <td class="text-right">{{ commaFormat(totals.total_refund_amount) }}</td>
                        <td class="text-right">{{ commaFormat(totals.net_collection) }}</td>
                        <td class="text-right" v-for="mop in mopHeads" :key="mop.key">
                          {{ commaFormat((totals.mop_heads && totals.mop_heads[mop.key]) || 0) }}
                        </td>
                    </tr>
                </tfoot>
            </table>
            <p v-if="! tableItems.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script setup>
import useDate from '@/services/utils/day';
import figureFormatter from "@/services/utils/figureFormatter";

const props = defineProps({
    tableItems: {
        type: Array
    },
    totals: {
        type: Object
    },
    mopHeads: {
        type: Array
    },
    reportType: {
        type: String,
        default: 'date_wise'
    }
});

const { formatToDdMmmYy } = useDate();
const { commaFormat } = figureFormatter();
</script>

<style>
.card-height{
    min-height: 200px
}
</style>